import { render, staticRenderFns } from "./EditBannerPPOBPopUp.vue?vue&type=template&id=1503ff95&scoped=true"
import script from "./EditBannerPPOBPopUp.vue?vue&type=script&lang=js"
export * from "./EditBannerPPOBPopUp.vue?vue&type=script&lang=js"
import style0 from "./EditBannerPPOBPopUp.vue?vue&type=style&index=0&id=1503ff95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1503ff95",
  null
  
)

export default component.exports